import ProductScore from "../station/ProductsScore";
import { FuelData } from "../data/FuelData";

export default function RaportProducts({data}) {

    const getFuel = (key, value) => {
        const found = FuelData.find(item => item.code === Number(value));
            return found ? found[key] : null;
    };

    function convertToArray(data) {
        return Object.entries(data)
            .map(([id, values]) => ({
                id,
                name: getFuel('name', id),
                color: getFuel('color', id),
                order: getFuel('order', id),
                ...values
            }))
            .sort((a, b) => a.order - b.order);
    };

    const products = convertToArray(data);
    return products && products.map(item => <ProductScore key={item.id} data={item}/>) 
}